import React from 'react';
import ReactTooltip from 'react-tooltip';

import Header from './Header';
import Footer from './Footer';
import Calculator from './Calculator';

export default class App extends React.Component {
  render() {
    return (
      <div className='pcb-calculator'>
        <ReactTooltip
            className='pcb-tooltip'
            effect='solid'
            delayHide={500}
            html={true}
        />

        <Header />
        <Calculator />
        <Footer />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js